import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Copy, ExternalLink, MessageSquare } from "lucide-react";

export const DiscordSetup = () => {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.get("/auth/discord/config").then(({ data }) => setCfg(data)).catch(() => {});
  }, []);

  if (!cfg?.enabled) return null;

  const copy = () => {
    const failed = () => toast.error("Copy blocked by the browser — select the URL and copy it manually");
    const p = navigator.clipboard?.writeText(cfg.redirect_uri);
    if (!p || typeof p.then !== "function") return failed();
    p.then(() => toast.success("Redirect URL copied")).catch(failed);
  };

  return (
    <div className="mt-4 border border-border bg-card p-8" data-testid="discord-setup-section">
      <div className="flex items-center gap-3">
        <MessageSquare className="h-5 w-5 text-primary" />
        <h3 className="text-lg font-semibold">Discord login setup</h3>
      </div>
      <p className="mt-4 max-w-3xl text-sm text-muted-foreground">
        Discord only accepts redirects that are listed on your application. If players see
        "Invalid OAuth2 redirect_uri", paste the URL below into Discord Developer Portal →
        your app → OAuth2 → Redirects, then hit Save Changes. The portal URL changes whenever the
        app moves to a new domain, so add every domain you use.
      </p>
      <div className="mt-6 flex flex-wrap items-center gap-3">
        <code
          className="mono flex-1 overflow-auto border border-border bg-secondary px-4 py-3 text-xs"
          data-testid="discord-redirect-uri"
        >
          {cfg.redirect_uri}
        </code>
        <Button variant="outline" className="rounded-none" onClick={copy} data-testid="copy-discord-redirect-btn">
          <Copy className="mr-2 h-4 w-4" /> Copy
        </Button>
        <Button asChild className="rounded-none" data-testid="open-discord-portal-btn">
          <a href="https://discord.com/developers/applications" target="_blank" rel="noreferrer">
            <ExternalLink className="mr-2 h-4 w-4" /> Discord portal
          </a>
        </Button>
      </div>
    </div>
  );
};
